import { apiClient, unwrapApi } from './http';

/**
 * Stock API — /stock/*
 */
export async function getStocks() {
  const { data } = await apiClient.get('/stock');
  return unwrapApi(data);
}

export async function getStock(id) {
  const { data } = await apiClient.get(`/stock/${id}`);
  return unwrapApi(data);
}

export async function createStock(payload) {
  const { data } = await apiClient.post('/stock', payload);
  return unwrapApi(data);
}

export async function updateStock(id, payload) {
  const { data } = await apiClient.put(`/stock/${id}`, payload);
  return unwrapApi(data);
}

export async function addStockQuantity(id, payload) {
  const { data } = await apiClient.post(`/stock/${id}/add`, payload);
  return unwrapApi(data);
}

export async function deleteStock(id) {
  const { data } = await apiClient.delete(`/stock/${id}`);
  return unwrapApi(data);
}

export async function getStockTransactions(id) {
  const { data } = await apiClient.get(`/stock/${id}/transactions`);
  return unwrapApi(data);
}

export async function getLowStockAlerts() {
  const { data } = await apiClient.get('/stock/alerts/low-stock');
  return unwrapApi(data);
}

export async function getStockSummaryOverview() {
  const { data } = await apiClient.get('/stock/summary/overview');
  return unwrapApi(data);
}

const stockService = {
  getStocks,
  getStock,
  createStock,
  updateStock,
  addStockQuantity,
  deleteStock,
  getStockTransactions,
  getLowStockAlerts,
  getStockSummaryOverview,
};

export default stockService;
